module.exports = __webpack_public_path__ + "img/circle-sm.e2896df8.png";